/* Package JSON Import will be here */
import queryString from "query-string";
/* Package JSON Import will be here */

/* Project Import will be here */
import { authTokenKey } from "services/index";
import { getErrorObject, errorToast } from "utilities/utils";
import { requestMobChangeOTPApi, updateMobileNoApi, requestChangeMobOtpApi, changeMobileNoApi } from "services/session";
import { updateUserDetailsAndNavigateToHome } from "./session";
import Constants from "../utilities/appConstants";
import { showMsgFromJson } from "reducers/common";
import { navigateToIndex } from "app/navigation";
import { logOut } from "reducers/session";
/* Project Import will be here */

export const types = {
    CLOSE_LOGIN_VERIFICATION_MODAL: "sessionOtpVerification/CLOSE_LOGIN_VERIFICATION_MODAL",
    LOAD_LOGIN_VERIFICATION_MODAL: "sessionOtpVerification/LOAD_LOGIN_VERIFICATION_MODAL",
    SHOW_LOGIN_VERIFICATION_MODAL: "sessionOtpVerification/SHOW_LOGIN_VERIFICATION_MODAL",
    SHOW_OR_HIDE_LOADER: "sessionOtpVerification/SHOW_OR_HIDE_LOADER"
};

const initialState = {
    isLoading: false,
    isShowVerificationModal: false,
    tempUser: null,
    tempToken: null,
    tempMobileNo: null,
    error: null
};

export const sessionOtpVerification = (state = initialState, action) => {
    switch (action.type) {
        case types.CLOSE_LOGIN_VERIFICATION_MODAL:
            return {
                ...state,
                isShowVerificationModal: false,
                isLoading: false,
                tempUser: null,
                tempToken: null,
                tempMobileNo: null,
                ...action.payload
            };
        case types.LOAD_LOGIN_VERIFICATION_MODAL:
            return {
                ...state,
                isLoading: true,
                ...action.payload
            };
        case types.SHOW_LOGIN_VERIFICATION_MODAL:
            return {
                ...state,
                isShowVerificationModal: true,
                isLoading: false
            };
        case types.SHOW_OR_HIDE_LOADER:
            return {
                ...state,
                isLoading: action.payload.isLoading
            };
        default:
            return state;
    }
};

/* Login OTP verification modal functionality */
export const toggleLoginOtpVerificationModal = (user, token, mobileNo) => {
    return async (dispatch, getState) => {
        /* close the modal if the modal already in open */
        if (getState().sessionOtpVerification.isShowVerificationModal) {
            dispatch(closeLoginOtpVerificationModal());
        }
        else {
            /* Initially load the verification modal and catch the temp user and token */
            dispatch({
                type: types.LOAD_LOGIN_VERIFICATION_MODAL,
                payload: { tempUser: user, tempToken: token, tempMobileNo: mobileNo }
            });
            try {
                await requestMobChangeOTPApi({
                    data: { mobileno: mobileNo },
                    headers: { [authTokenKey]: token }
                });
                dispatch({ type: types.SHOW_LOGIN_VERIFICATION_MODAL });
            }
            catch (error) {
                dispatch(promiseCatchBlock(error));
            }
        }
    };
};

export const resendLoginOtp = (token, mobileNo) => {
    return async (dispatch, getState) => {
        /* Initially load the verification modal and catch the temp user and token */
        dispatch({ type: types.LOAD_LOGIN_VERIFICATION_MODAL });
        try {
            await requestMobChangeOTPApi({
                data: { mobileno: mobileNo },
                headers: { [authTokenKey]: token }
            });
            dispatch({ type: types.SHOW_LOGIN_VERIFICATION_MODAL });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error));
        }
    };
};

/* Call and validate the requested OTP from login validation */
export const loginOtpValidate = (otp: string) => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.SHOW_OR_HIDE_LOADER,
            payload: { isLoading: true }
        });

        try {
            let sessionOtpVerificationState = getState().sessionOtpVerification;
            const response = await updateMobileNoApi({
                data: {
                    otp: otp,
                    mobileno: sessionOtpVerificationState.tempMobileNo
                },
                headers: {
                    [authTokenKey]: sessionOtpVerificationState.tempToken
                }
            })

            /* If the mobile number updated successfully proceed the retailer to access the application */
            if (response.data.Status === 1) {
                dispatch(updateUserDetailsAndNavigateToHome(
                    sessionOtpVerificationState.tempUser,
                    sessionOtpVerificationState.tempToken
                ));
            }

            /* Close the OTP modal */
            dispatch(closeLoginOtpVerificationModal());
        }
        catch (error) {
            dispatch(promiseCatchBlock(error));

            /* If the failure from direct login redirect the retailer to login screen */
            const query = queryString.parse(window.location.search);
            if (query && query.mob)
                dispatch(navigateToIndex());
        }
    };
};

/* updateDirectMobileNumber - Update the mobile number without any authentication (OTP) - Only for JNJ */
export const updateDirectMobileNumber = (mobileNumber: string, token: string, user: string) => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.SHOW_OR_HIDE_LOADER,
            payload: { isLoading: true }
        });

        try {
            const response = await updateMobileNoApi({
                data: {
                    otp: null,
                    mobileno: mobileNumber
                },
                headers: { [authTokenKey]: token }
            })

            /* If the mobile number updated successfully proceed the retailer to access the application */
            if (response.data.Status === 1) {
                dispatch(updateUserDetailsAndNavigateToHome(user, token));
            }

            dispatch({
                type: types.SHOW_OR_HIDE_LOADER,
                payload: { isLoading: false }
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error));
        }
    };
};

/* Change Mobile Number action methods */
export const requestChangeMobileNumberOtp = (OldMobileNo, mobileNo) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.LOAD_LOGIN_VERIFICATION_MODAL });
        try {
            await requestChangeMobOtpApi({
                data: {
                    oldmobileno: OldMobileNo,
                    mobileno: mobileNo
                }
            });
            dispatch({ type: types.SHOW_LOGIN_VERIFICATION_MODAL });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error));
        }
    };
};

export const mobileChangeOtpValidate = (otp: string, newMobileNumber: string) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.SHOW_OR_HIDE_LOADER, payload: { isLoading: true } });

        try {
            await changeMobileNoApi({ data: { otp: otp, mobileno: newMobileNumber } });

            dispatch(closeLoginOtpVerificationModal());
            dispatch(showMsgFromJson(`settings.changeMob.UpdatedMobNoSuccess`, Constants.SUCCESS));

            /* Logout the retailer automatically when the successful mobile number change */
            dispatch(logOut());
        }
        catch (error) {
            dispatch(promiseCatchBlock(error));
        }
    };
};
/* Change Mobile Number action methods */

/* Close the OTP modal */
const closeLoginOtpVerificationModal = () => {
    return {
        type: types.CLOSE_LOGIN_VERIFICATION_MODAL
    };
};

const promiseCatchBlock = (error: any) => {
    return (dispatch) => {
        /* Extract the error message and error code from the response object */
        const { message, errorCode } = getErrorObject(error);

        dispatch({
            type: types.CLOSE_LOGIN_VERIFICATION_MODAL,
            payload: { error: message }
        });

        /* If error code is exist show the error code message or show the error message returned by the API request */
        if (errorCode !== "")
            dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
        else
            errorToast({ content: message });
    }
};